import { render } from "./Q16-ChooseMan.vue?vue&type=template&id=0883c8ac&scoped=true"
import script from "./Q16-ChooseMan.vue?vue&type=script&lang=js"
export * from "./Q16-ChooseMan.vue?vue&type=script&lang=js"

import "./Q16-ChooseMan.vue?vue&type=style&index=0&id=0883c8ac&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0883c8ac"]])

export default __exports__